import Operation from "../index.js";

export default {
  //登录
  communityLogin(params, fn) {
    return Operation.Http.post(`/authorization/communityLogin`, params, fn)
  },
  //修改密码
  updateStudentPwd(params, fn) {
    let { oldPwd, newPwd } = params;
    return Operation.Http.post(`/authorization/updateStudentPwd?oldPwd=${oldPwd}&newPwd=${newPwd}`, params, fn)
  },
  //社区选择账号
  communitySwitchAccount(params, fn) {
    let { userId, type } = params;
    Operation.Http.post(`/authorization/communitySwitchAccount?userId=${userId}&type=${type}`, null, fn)
  },
  //找回密码提交
  communityUpdatePwdByCode(params, fn) {
    let { phone, code, pwd } = params;
    Operation.Http.post(`/authorization/communityUpdatePwdByCode?phone=${phone}&code=${code}&pwd=${pwd}`, params, fn)
  },

}


// WEBPACK FOOTER //
// ./src/request/api/authorization.js